/* eslint-disable no-unused-expressions */
/* eslint-disable react/no-unused-state */
import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { templateStrings } from "../../../Constant";
import { TableWrapper } from "../../../shared/layout";
import { fetchPendingAllSettlementsAction, fetchSettledSettlementsAction } from "../../../redux/action-creators/settlementActionCreator";

class DuesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageNo: 0,
      rowsPerPage: 10,
      count: 100,
      backdrop: false,
      sortBy: "",
      selected: [],
    };
    this.getList = this.getList.bind(this);
    this.handleAction = this.handleAction.bind(this);
    this.onSortToggle = this.onSortToggle.bind(this);
  }

  componentDidMount() {
    this.getList();
  }

  componentDidUpdate(prevProps) {
    const { searchString, cityFilter, operatorFilter } = this.props;
    if (
      (prevProps && prevProps.searchString !== searchString)
      || (prevProps && prevProps.cityFilter !== cityFilter)
      || (prevProps && prevProps.operatorFilter !== operatorFilter)
    ) {
      this.getList();
    }
  }

  handleAction(vehicleDetails) {
    const { history } = this.props;
    history.push("/settlement/operator-settlement", vehicleDetails);
  }

  onSortToggle(value, key) {
    this.setState(
      {
        sortBy: { [key]: value },
      },
      () => {
        this.getList();
      },
    );
  }

  /**
   * API call to get vehicles.
   * @param pageNo current page number
   */
  getList() {
    const {
      type, fetchPendingDues, operatorFilter, cityFilter, fetchSettledDues,
    } = this.props;
    const { pageNo, rowsPerPage, sortBy } = this.state;
    type === "pending"
      ? fetchPendingDues({
        pageNo,
        pageSize: rowsPerPage,
        operatorFilter,
        cityFilter,
        sortBy,
      })
      : fetchSettledDues({
        pageNo,
        pageSize: rowsPerPage,
        operatorFilter,
        cityFilter,
        sortBy,
      });
  }

  handleChange = (input, value) => {
    this.setState({ [input]: value }, () => {
      if (input === "pageNo") {
        this.getList();
      }
    });
  };

  render() {
    const {
      headerLoader, content, totalItems, type,
    } = this.props;
    const {
      selected, pageNo, rowsPerPage, sortBy,
    } = this.state;
    const templateString = type === "pending" ? templateStrings.pendingDues : templateStrings.settledDues;

    return (
      <div>
        <TableWrapper
          content={!headerLoader && content}
          selected={selected}
          pageNo={pageNo}
          uniqueKey="busNumber"
          rowsPerPage={rowsPerPage}
          count={totalItems}
          handleChange={this.handleChange}
          templateString={templateString}
          selectionAllowed={false}
          actionName="Details"
          handleAction={this.handleAction}
          onSortToggle={this.onSortToggle}
          sortBy={sortBy}
        />
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    content:
    (ownProps.type === "pending"
      ? state?.Settlement?.pendingSettlements?.items
      : state?.Settlement?.settledSettlements?.items) || [],
    totalItems:
    (ownProps.type === "pending"
      ? (state
        && state.Settlement
        && state.Settlement.pendingSettlements
        && state.Settlement.pendingSettlements.totalItems)
      : (state
            && state.Settlement
            && state.Settlement.settledSettlements
            && state.Settlement.settledSettlements.totalItems))
        || 0,
    headerLoader: (state && state.loadingBar && state.loadingBar.header),
    cityFilter: state.Cities.selectedCity,
    operatorFilter: state.Operators.selectedOperator,
  };
}

const mapDispatchToProps = (dispatch) => ({
  fetchPendingDues: (params) => {
    dispatch(fetchPendingAllSettlementsAction(params));
  },
  fetchSettledDues: (params) => {
    dispatch(fetchSettledSettlementsAction(params));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DuesList));
